import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MuiBreadcrumbsModule } from '../breadcrumbs';
import { MuiButtonModule } from '../button';
import { MuiIconModule } from '../icon';
import { MuiStickyModule } from '../sticky';
import { MuiUtilityModule } from '../utility';
import { MuiHeroActionButton } from './mui-hero-action/mui-hero-action-button.component';
import { MuiHeroContent } from './mui-hero-content/mui-hero-content.component';
import { MuiHeroCurrentTimeComponent } from './mui-hero-current-time/mui-hero-current-time.component';
import { MuiHeroPageTitleComponent } from './mui-hero-page-title/mui-hero-page-title.component';
import { MuiRightAppBarContent } from './mui-hero-right-app-bar/mui-hero-right-app-bar.component';
import { MuiHeroScrollFab } from './mui-hero-scroll-fab/mui-hero-scroll-fab.component';
import { MuiHeroComponent } from './mui-hero/mui-hero.component';


@NgModule({
  declarations: [
    MuiHeroComponent,
    MuiHeroContent,
    MuiHeroPageTitleComponent,
    MuiHeroActionButton,
    MuiHeroScrollFab,
    MuiRightAppBarContent,
    MuiHeroCurrentTimeComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MuiButtonModule,
    MuiBreadcrumbsModule,
    MuiIconModule,
    MuiUtilityModule,
    MuiStickyModule
  ],
  exports: [
    MuiHeroComponent,
    MuiHeroContent,
    MuiRightAppBarContent,
    MuiHeroPageTitleComponent,
    MuiHeroActionButton,
    MuiHeroCurrentTimeComponent,
    MuiHeroScrollFab
  ]
})
export class MuiHeroAreaModule {
}
